/*
  ___ _  _ _____ _   _ ___ _____ _____   _____    
 |_ _| \| |_   _| | | |_ _|_   _|_ _\ \ / / __| TM
  | || .` | | | | |_| || |  | |  | | \ V /| _|    
 |___|_|\_|_|_|__\___/|___|_|_|_|___| \_/_|___| __
 |   \| __|  \/  |/ _ \ / __| _ \  /_\ / __\ \ / /
 | |) | _|| |\/| | (_) | (__|   / / _ \ (__ \ V / 
 |___/|___|_|  |_|\___/ \___|_|_\/_/ \_\___| |_|  

 © Manuel Valle C. - AromaItaliano SA, Costa Rica

*/

(function () {
	//IIFE - (Immediately Invoked Function Expression)
	//https://github.com/NodeBB-Community/nodebb-plugin-frontend-lodash/blob/master/public/requirejs-inject.js
	// to prevent changing of NodeBB templates inject modules directly to RequireJS
	var rjsConfig = requirejs.s.contexts._.config,
		pluginPrefix = '',
		pluginPath = '../../plugins/nodebb-plugin-picapp/npm/';
	var registerAMD = function (name, path) {
		if (!rjsConfig.paths[pluginPrefix + name])
			rjsConfig.paths[pluginPrefix + name] = pluginPath + path;
	};

	registerAMD('lodash', 'lodash/lodash.min');
	registerAMD('moment', 'moment/min/moment.min');
})();
